var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPayment(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Billings_-_Blue",
    "data-name": "Billings - Blue",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cashback_1_",
    "data-name": "cashback (1)",
    transform: "translate(0.412 0.412)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_496",
    "data-name": "Path 496",
    className: "cls-2",
    d: "M1.685,308.8H.486A.486.486,0,0,1,0,308.318v-5.832A.486.486,0,0,1,.486,302h1.2a.486.486,0,0,1,.486.486v5.832A.486.486,0,0,1,1.685,308.8Z",
    transform: "translate(0 -292.216)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497",
    "data-name": "Path 497",
    className: "cls-2",
    d: "M109.838,313.193a1.173,1.173,0,0,0-1.193.037l-1.778,1.126a2.108,2.108,0,0,1-2.091,1.856h-2.416a.5.5,0,0,1-.5-.462.486.486,0,0,1,.485-.509h2.43a1.135,1.135,0,0,0,1.134-1.161,1.148,1.148,0,0,0-1.155-1.107h-2.733l-.317-.238a3.671,3.671,0,0,0-4.091-.211l-.613.368v4.94h8.168a2.43,2.43,0,0,0,1.33-.4l3.416-2.234a1.173,1.173,0,0,0-.076-2.009Z",
    transform: "translate(-93.857 -301.892)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_498",
    "data-name": "Path 498",
    className: "cls-2",
    d: "M91.05,0A4.05,4.05,0,1,0,95.1,4.05,4.054,4.054,0,0,0,91.05,0Zm.486,6.061v.095a.486.486,0,0,1-.972,0v-.1a1.3,1.3,0,0,1-.784-.942.486.486,0,0,1,.953-.193.324.324,0,1,0,.317-.389,1.3,1.3,0,0,1-.486-2.5V1.944a.486.486,0,0,1,.972,0v.1a1.3,1.3,0,0,1,.784.942.486.486,0,0,1-.953.193.324.324,0,1,0-.317.389,1.3,1.3,0,0,1,.486,2.5Z",
    transform: "translate(-84.181)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_499",
    "data-name": "Path 499",
    className: "cls-2",
    d: "M331.772,25.763a.486.486,0,0,0-.44-.28h-.707a8.291,8.291,0,0,0-4.84-5.615,5.016,5.016,0,0,1,1.2,4.579,5.409,5.409,0,0,1,.566,1.035h-.428a.486.486,0,0,0-.373.8l2.106,2.527a.486.486,0,0,0,.747,0l2.106-2.527A.486.486,0,0,0,331.772,25.763Z",
    transform: "translate(-315.23 -19.225)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/payment.e9d9228d05ad07a1982c954a2be860dd.svg";
export { ForwardRef as ReactComponent };